export default __webpack_public_path__ + "static/yoshihiro-e3e43b369cd424ef9d4b3c63f4e365f1.jpg";